import React from 'react';
import SchoolListItem from './SchoolListItem';

class SchoolList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleToggleRecipient = this.handleToggleRecipient.bind(this); // toggle single recipient
    this.handleToggleAllPagedRecipients = this.handleToggleAllPagedRecipients.bind(this); // toggle all recipients in page
    this.arePagedRecipientsAllSelected = this.arePagedRecipientsAllSelected.bind(this); // are all recipients in this page selected?
    this.handleRecipientListUpdate = this.handleRecipientListUpdate.bind(this);
  }

  arePagedRecipientsAllSelected() {
    let allSelected = true;

    for (let i=0; i<this.props.schools.length; i++) {
      const school = this.props.schools[i];

      if (this.props.recipientList[school.id] == undefined) {
        allSelected = false;

        break;
      }
    }

    return allSelected;
  }

  handleToggleRecipient(recipient) {
    let recipients = this.props.recipientList;

    if (recipients[recipient.id]) {
      delete recipients[recipient.id];
    } else {
      recipients[recipient.id] = recipient;
    }

    return this.handleRecipientListUpdate(recipients);
  }

  // NOTE: this function requires recipients as parameters instead of getting it from props so that we can share this function across schools/teachers
  handleToggleAllPagedRecipients(e, nextRecipients) {
    const shouldCheckNotUncheck = e.currentTarget.checked;
    let recipients = this.props.recipientList;

    nextRecipients.forEach((recipient) => {
      if (shouldCheckNotUncheck) {
        recipients[recipient.id] = recipient;
      } else {
        delete recipients[recipient.id];
      }
    });

    this.handleRecipientListUpdate(recipients);
  }

  handleRecipientListUpdate(recipients) {
    if (this.props.onRecipientListUpdate) {
      this.props.onRecipientListUpdate(recipients, 'schools');
    }
  }

  render() {
    return (
      <table width="100%" className="table mt-4">
        <thead>
          <tr>
            {
              this.props.onRecipientListUpdate ? (
                <td>
                  <input type="checkbox" checked={this.arePagedRecipientsAllSelected() ? 'checked' : false} onClick={(e) => this.handleToggleAllPagedRecipients(e, this.props.schools)} />
                </td>
              ) : ''
            }
            {/* <td width="1%">ID/C.M.</td> */}
            <td width="15%">Plesso /scuola</td>
            <td width="25%">Indirizzo</td>
            <td width="15%">Telefono/ Fax</td>
            <td width="10%">Email/ PEC</td>
            {/* <td width="5%" align="center"><i className="fa fa-gift" /></td>
            <td width="5%" align="center"><i className="fa fa-chalkboard-teacher" /></td> */}
            {/* <td width="10%" align="center"><i className="fa fa-envelope" /></td> */}
            <td width="15%">Istituto principale</td>
          </tr>
        </thead>
        <tbody>
          {
            this.props.schools.length ? (
              this.props.schools.map((school) => {
                const hasRecipient = this.props.recipientList != undefined && this.props.recipientList[school.id] != undefined;

                return (
                  <SchoolListItem
                    key={'school-' + school.id}
                    school={school}

                    hasRecipient={hasRecipient}
                    onToggleRecipient={this.props.onRecipientListUpdate ? (e) => {
                      this.handleToggleRecipient(school)
                    } : null}
                  />
                );
              })
            ) : (
              ''
            )
          }
        </tbody>
      </table>
    );
  }
}

export default SchoolList;


// WEBPACK FOOTER //
// ./src/components/schools/SchoolList.js